import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// SERVICES
import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  refreshToken(token :string) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV1}/auth/refresh`,
      body: { token },
    });
  }
}
